import {$dom} from '../../helpers/dom';
import FormValidator  from '@yaireo/validator';
import {$events} from '../../helpers/events';
import {preventDefault} from '../../helpers/_utilities';

const {
	exist,
	callAll,
	attr,
	get
} = $dom;

export function formValidation(
	formSelector = '.js-form-validate',
	criticalCheckboxSelector = '.js-critical-checkbox',
	submitButtonSelector ='.button[type=submit]'
) {

	if (exist(formSelector)) {

		const validator = new FormValidator({
			texts: {
				invalid         : 'Некорректное значение поля',
				short           : 'Слишком короткое значение',
				long            : 'Слишком длинное значение',
				checked         : 'must be checked',
				empty           : 'Пожалуйста, заполните это поле',
				select          : 'Please select an option',
				number_min      : 'too low',
				number_max      : 'too high',
				url             : 'invalid URL',
				number          : 'not a number',
				email           : 'Некорректный email',
				email_repeat    : 'emails do not match',
				date            : 'invalid date',
				time            : 'invalid time',
				password_repeat : 'passwords do not match',
				no_match        : 'no match',
				complete        : 'Ввод не завершён'
			},
			alerts: true,
			classes: {
				item  : 'form__group',
				alert : 'form__error',
				bad   : 'is-error'
			}
		}, null);

		function checkCriticalCheckbox(form) {
			if (exist(criticalCheckboxSelector, form)) {
				const
					checkbox = get(`${criticalCheckboxSelector} input[type=checkbox]`, form),
					submitButton = get(submitButtonSelector, form)
				;

				if (checkbox.checked) {
					submitButton.removeAttribute('disabled')
				} else {
					attr(submitButton, 'disabled', 'true');
				}
			}
		}

		const
			init = () => {
				callAll(formSelector, form => {
					attr(form, 'novalidate', '');
					checkCriticalCheckbox(form)
				});

				$events.delegate
					.on('submit', formSelector, event => {
						if (!validator.checkAll(event.target).valid) preventDefault(event)
					})
					.on('change', criticalCheckboxSelector, event => {
						checkCriticalCheckbox(event.target.closest(formSelector))
					})
				;


			},
			destroy = () => {
				callAll(formSelector, form => form.removeAttribute('novalidate'));
			}
		;

		return {init, destroy}
	}
	return null;
}
